import { useEffect } from "react";
import { useLang } from "@/i18n";

function setMeta(attr, key, content) {
    if (!content) return;
    let el = document.head.querySelector(`meta[${attr}="${key}"]`);
    if (!el) {
        el = document.createElement("meta");
        el.setAttribute(attr, key);
        document.head.appendChild(el);
    }
    el.setAttribute("content", content);
}

function setLink(rel, href) {
    let el = document.head.querySelector(`link[rel="${rel}"]`);
    if (!el) {
        el = document.createElement("link");
        el.setAttribute("rel", rel);
        document.head.appendChild(el);
    }
    el.setAttribute("href", href);
}

/**
 * Lightweight per-page SEO for the CSR app.
 * Sets <title>, description, Open Graph, Twitter, canonical and <html lang>.
 */
export default function Seo({ title, description, image, path = "" }) {
    const { lang } = useLang();
    useEffect(() => {
        const fullTitle = `${title} | Gruppo CB`;
        document.title = fullTitle;
        document.documentElement.lang = lang;

        const origin = window.location.origin;
        const url = `${origin}${path || window.location.pathname}`;
        const img = image || "https://images.unsplash.com/photo-1772299121503-cd62a57e3a26?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200";

        setMeta("name", "description", description);
        setMeta("property", "og:title", fullTitle);
        setMeta("property", "og:description", description);
        setMeta("property", "og:type", "website");
        setMeta("property", "og:url", url);
        setMeta("property", "og:image", img);
        setMeta("property", "og:site_name", "Gruppo CB srl");
        setMeta("property", "og:locale", lang === "it" ? "it_IT" : "en_US");
        setMeta("name", "twitter:card", "summary_large_image");
        setMeta("name", "twitter:title", fullTitle);
        setMeta("name", "twitter:description", description);
        setMeta("name", "twitter:image", img);
        setLink("canonical", url);
    }, [title, description, image, path, lang]);

    return null;
}
